export default __webpack_public_path__ + "static/media/link.dca07da4.svg";